import { Bot } from "lucide-react";
import { Label } from "@/components/ui/label";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface AutoFilledLabelProps {
  htmlFor?: string;
  children: React.ReactNode;
  isAutoFilled: boolean;
}

export function AutoFilledLabel({ htmlFor, children, isAutoFilled }: AutoFilledLabelProps) {
  return (
    <div className="flex items-center gap-1.5">
      <Label htmlFor={htmlFor}>{children}</Label>
      {isAutoFilled && (
        <TooltipProvider delayDuration={200}>
          <Tooltip>
            <TooltipTrigger asChild>
              <Bot className="w-3.5 h-3.5 text-primary/60 shrink-0" />
            </TooltipTrigger>
            <TooltipContent side="top">
              <p className="text-xs">Preenchido automaticamente pelo Robô</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  );
}
